import React from "react";
import { Grid, Box, Card, Skeleton } from "@mui/material";

const ProductListSkeleton = () => {
  // We mock a list of 8 items to fill up the grid row elegantly during loading
  const skeletonItems = Array.from({ length: 8 });

  return (
    <Grid container spacing={2} mb={4}>
      {skeletonItems.map((_, index) => (
        <Grid
          item
          xs={6}
          sm={4}
          md={4}
          lg={3}
          xl={3}
          key={`skeleton-${index}`}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Image Placeholder matches Card dimensions exactly */}
            <Card
              sx={{
                borderRadius: "10px",
                width: { xs: 170, sm: 190, md: 210, lg: 220, xl: 250 },
                height: {
                  xs: 135,
                  sm: 140,
                  md: 150,
                  lg: 170,
                },
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                sx={{ borderRadius: 2 }}
              />
            </Card>

            {/* Product Title Placeholder */}
            <Box sx={{ mt: 1, px: 0.5 }}>
              <Skeleton
                variant="text"
                width="80%"
                height={20}
                sx={{ borderRadius: "4px" }}
              />
            </Box>

            {/* Discount Price Placeholder */}
            <Box sx={{ mt: 0.5, px: 0.5 }}>
              <Skeleton
                variant="text"
                width="50%"
                height={18}
                sx={{ borderRadius: "4px" }}
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(ProductListSkeleton);